"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hexStringToColor = exports.hexStringToNumber = void 0;
var realms_three_1 = __importDefault(require("realms-three"));
var hexStringToNumber = function (hexString) {
    return Number("0x".concat(hexString.replaceAll("#", "")));
};
exports.hexStringToNumber = hexStringToNumber;
var hexStringToColor = function (hexString) {
    return new realms_three_1.default.Color((0, exports.hexStringToNumber)(hexString));
};
exports.hexStringToColor = hexStringToColor;
